import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import { RowDataRawOrder, STORE_ORDERRAWDATA, STORE_ORDERRAWDATA_EXPORT, STORE_ORDRAW_ENDDATE, STORE_ORDRAW_STARTDATE } from 'src/reducers/completeorderfile';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { commonDateFormat } from './completedOrderDateAction';
import { transformDataforExport } from './manufacturAction';

export interface DataParamType {
    fdate: string | null;
    tdate: string | null;
    fcaseno: string | null;
    tcaseno: string | null;
    ptz: string;
}

// const transformDataforExportq = (data: RowDataRawOrder[], dateFields: string[], dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}/api/getModifiedDataforExport`,
//         data: { data, dateFields },
//         headers: {
//             'Access-Control-Allow-Origin': '*',
//             'Content-Type': 'application/json',
//             sessionid: getState().user.userDetails.s || ''
//         }
//     })
//         .then((result) => {

//             const orderrawdataExport: RowDataRawOrder[] = result.data;
//             dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);
//         })
//         .catch((error) => {
//             const orderrawdataExport: RowDataRawOrder[] = [];
//             dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);
//         });

// };

export const getArchiveData = (getDate: string, fcaseno: string, tcaseno: string, timezone: string) => {
    return async (
        dispatch: Dispatch<AppState>,
        getState: () => AppState
    ) => {

        const dataParam: DataParamType = {
            fdate: null,
            tdate: null,
            fcaseno: null,
            tcaseno: null,
            ptz: timezone
        };

        const today = new Date();

        if (getDate === 'get') {
            if (fcaseno && tcaseno) {
                dataParam.fcaseno = fcaseno;
                dataParam.tcaseno = tcaseno;
            } else {
                dataParam.fdate = commonDateFormat(getState().completeOrder.startDateRaw || today, 'date') || null;
                dataParam.tdate = commonDateFormat(getState().completeOrder.endDateRaw || today, 'date') || null;
            }

        } else {
            dataParam.fdate = commonDateFormat(today, 'date') || null;
            dataParam.tdate = commonDateFormat(today, 'date') || null;

            const startDateRaw = today;
            const endDateRaw = today;

            dispatch({ type: STORE_ORDRAW_STARTDATE, startDateRaw } as AnyAction);
            dispatch({ type: STORE_ORDRAW_ENDDATE, endDateRaw } as AnyAction);
        }

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL
                }getRawData?listType=ordrawdt&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
            data: dataParam,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: getState().user.userDetails.s || ''
            }
        }).then(async function (response: AxiosResponse) {

            if (response.data.length === 1) {
                if (response.data[0].orderno !== '') {
                    const orderrawdata: RowDataRawOrder[] = response.data;
                    dispatch({ type: STORE_ORDERRAWDATA, orderrawdata } as AnyAction);

                    const orderrawdataExport = await transformDataforExport(orderrawdata, ['casein_ordercreateddatetime', 'qcout_designcompleted'], dispatch, getState);
                    dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);

                } else {
                    const orderrawdata: RowDataRawOrder[] = [];
                    dispatch({ type: STORE_ORDERRAWDATA, orderrawdata } as AnyAction);
                    const orderrawdataExport: RowDataRawOrder[] = [];
                    dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);
                }
            } else {
                const orderrawdata: RowDataRawOrder[] = response.data;
                dispatch({ type: STORE_ORDERRAWDATA, orderrawdata } as AnyAction);

                const orderrawdataExport = await transformDataforExport(orderrawdata, ['casein_ordercreateddatetime', 'qcout_designcompleted'], dispatch, getState);
                dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);
            }
        }).catch(function (error: AxiosError) {
            const orderrawdata: RowDataRawOrder[] = [];
            dispatch({ type: STORE_ORDERRAWDATA, orderrawdata } as AnyAction);
            const orderrawdataExport: RowDataRawOrder[] = [];
            dispatch({ type: STORE_ORDERRAWDATA_EXPORT, orderrawdataExport } as AnyAction);
        });

    };
};

export const savefromDate = (startDateRaw: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_ORDRAW_STARTDATE, startDateRaw } as AnyAction);
    };
};

export const savetoDate = (endDateRaw: Date | null) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_ORDRAW_ENDDATE, endDateRaw } as AnyAction);
    };
};



// WEBPACK FOOTER //
// ./src/actions/orderRawDataActions.ts